import script from "./AdminMessagesList.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMessagesList.vue?vue&type=script&setup=true&lang=js"

import "./AdminMessagesList.vue?vue&type=style&index=0&id=de9e5b1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de9e5b1a"]])

export default __exports__